import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5117a053"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "task-card"
};
const _hoisted_2 = {
  class: "category-type"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "top"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "font10"
};
const _hoisted_7 = {
  class: "bottom"
};
const _hoisted_8 = {
  class: "top-background"
};
const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "font10 subTitle"
}, "释义", -1));
const _hoisted_11 = {
  class: "font10"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "font10 subTitle"
}, "可解决该任务的参考算法/模型：", -1));
const _hoisted_13 = {
  class: "font10"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_divider = _resolveComponent("el-divider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "task-card-item",
      key: index
    }, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.categoryType, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "category-type-item",
        key: index
      }, [_createElementVNode("img", {
        src: $setup.handleCategory(item).circleImg
      }, null, 8, _hoisted_3)]);
    }), 128))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.titleEn), 1)]), _createElementVNode("div", {
      class: "center",
      style: _normalizeStyle({
        backgroundImage: `url(${item.imgUrl})`
      })
    }, null, 4), _createVNode(_component_el_divider, null, {
      default: _withCtx(() => [_createTextVNode("应用领域")]),
      _: 1
    }), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.buttonList, (it, i) => {
      return _openBlock(), _createElementBlock("button", {
        class: "btn-item font10",
        key: i
      }, _toDisplayString(it.title), 1);
    }), 128))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_hoisted_10, _createElementVNode("p", _hoisted_11, _toDisplayString(item.interpretation), 1)]), _createElementVNode("div", null, [_hoisted_12, _createElementVNode("p", _hoisted_13, _toDisplayString(item.solve), 1)])])])]);
  }), 128))]);
}